import api from './api';
import { Customer } from './customers';

export interface CustomerLoginCredentials {
  ic_passport_no: string;
  password: string;
}

export const customerAuthService = {
  async login(credentials: CustomerLoginCredentials) {
    const response = await api.post('/customer/login', credentials);
    const { token, customer, must_change_password } = response.data.data;
    localStorage.setItem('customer_token', token);
    localStorage.setItem('customer', JSON.stringify(customer));
    localStorage.setItem('customer_must_change_password', must_change_password ? '1' : '0');
    return { token, customer, must_change_password };
  },

  async logout() {
    localStorage.removeItem('customer_token');
    localStorage.removeItem('customer');
    localStorage.removeItem('customer_must_change_password');
  },

  getCurrentCustomer(): Customer | null {
    const customerStr = localStorage.getItem('customer');
    if (customerStr) {
      return JSON.parse(customerStr);
    }
    return null;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('customer_token');
  },

  mustChangePassword(): boolean {
    // Check both localStorage flag and customer object
    const flag = localStorage.getItem('customer_must_change_password');
    if (flag === '0') {
      return false;
    }
    if (flag === '1') {
      return true;
    }
    // If flag is not set, check customer object
    const customer = this.getCurrentCustomer();
    if (customer && customer.is_change_password === false) {
      return true;
    }
    return false;
  },
};

